
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MyProfileActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class MyProfileEmailEffects {

  constructor(
    private actions$: Actions,
    private readonly apiService: ApiService,
    private globalService: GlobalService,
  ) { }

  protected logger = inject(LoggerService);

  FetchMyProfile$: Observable<
    ReturnType<typeof MyProfileActions.updateAlternativeEmailSuccess> |
    ReturnType<typeof MyProfileActions.updateAlternativeEmailFail>
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyProfileActions.updateAlternativeEmail),
      switchMap((action) => this.apiService.updateEmail(action.requestObject)),
      map(() => {
        this.globalService.loadingSubject.next(false);
        return MyProfileActions.updateAlternativeEmailSuccess({ payload: true });
      }),
      catchError((error) =>
        of(MyProfileActions.updateAlternativeEmailFail({ error: tryNormalizeHttpError(error, this.logger) }))
      )
    )
  );

}